module.exports = __webpack_public_path__ + "img/painting.be5030ca.webp";